<!--&lt;!&ndash;关于&ndash;&gt;-->
<template>
  <div>
    <Row>
      <Col span="22">
        <div class="container_wang_company">
          <table>
            <tr>
              <td class="title" colspan="2">关于</td>
            </tr>
            <tr>
              <td style="height: 200px">中朗商业保理</td>
              <td style="height: 200px">
                <img src="../../assets/about.png">
              </td>
            </tr>
            <tr>
              <td>功能介绍</td>
              <td>
                中朗商业保理有限公司（简称“中朗保理”）是一家注册在上海的商业保理公司，注册资本5000万元，
                公司团队由来自于国内外知名学府，具有丰富经验的专业人士组成，股东是江苏康美企业管理有限公司，实力雄厚。
                 从事与本公司所受让的应收账款相关的应收账款保理、销售分账户管理、应收账款催收、坏账担保的业务。
              </td>
            </tr>
            <tr>
              <td>当前版本</td>
              <td>{{tableData.version}}</td>
            </tr>
          </table>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
  import ApiClient from "@/api/ApiClient";

  export default {
    name: "about",
    data() {
      return {
        tableData: {}
      }
    },
    mounted() {
      ApiClient.get('/desktop/profile/version.do').then(data => {
        this.tableData = data;
      })
    }
  }
</script>

<style scoped lang="less">

  .title {
    font-weight: 700;
  }

  table {
    border-collapse: collapse;
    margin-left: 60px;
    margin-top: 16px;
    width: 100%;
    tr td {
      border: 1px solid #D8D8D8;
      height: 42px;
      padding-left: 20px;
    }
    tr td:nth-child(2n+1) {
      width: 17%;
    }
    tr td:nth-child(2n) {
      width: 57%;
    }
  }

  table tr:nth-child(1), table tr:nth-child(3), table tr:nth-child(5), table tr:nth-child(7) {
    background-color: #F6F6F5;
  }

</style>

<style lang="less">
  .container_wang_company .ivu-input {
    width: 50%;
    margin-left: -10px;
  }

  .container_wang_company button {
    margin-left: 46%;
    margin-top: 60px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/myProfile/about.vue